import React, { Component } from 'react';
import parse from 'html-react-parser';
import { Card, Modal, Badge } from "react-bootstrap";
import { FaPen, FaTrash, FaRegThumbsUp, FaRegThumbsDown, FaThumbsUp, FaThumbsDown } from "react-icons/fa6";
import { GetText, ReplacePrefixUrl, ReplaceOutputTextHTML } from '../../config/helper';
import DateTimeFormats from '../../config/date-time-format';
import DiscussionFormReply from './FormReply';
// import DiscussionForm from './Form';
// import PromptDetail from './Detail';
// import NAimage from '../../img/pic-na.png';

const authKey = global.config.kindcode.training[22]+global.config.authBearerKey;

export default class Block extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      currPage: '',
      // activePage: '',
      threadid: '',
      threadtitle: '',
      id: '',
      description: '',
      status: '',
      createbyid: '',
      createby: '',
      createon: '',
      lastupdate: '',
      data: {},
      modal_show_reply: false,
      modal_content_reply: {},
      modal_title_reply: '',

      // modal_show_detail: false,
      // memberStatus: localStorage.getItem('status')
    }
  }
  handlePopOpen(name, name_title, title, name_content, content) {
    var sendcontent = {};
    sendcontent.data = content;
    sendcontent.currpage = this.state.currPage;
    // sendcontent.activepage = this.state.activePage;

    // {{"currpage": this.state.currentUrl, "activepage": this.state.activePage, "data":this.state.data}}

    this.setState({ 
      [name]: true,
      [name_title]: title,
      [name_content]: sendcontent
    });
  }
  handlePopClose(name, name_title, name_content) {
    this.setState({ 
      [name]: false,
      [name_title]: '',
      [name_content]: ''
    });
  }
  handleOpenPage(url) {
    window.location.href=url;
  }
  
  handlePublish(docid,valId,nextstat) {
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this response?");
    if(stat === true) {
      var datatext ='{"thread_docid":"'+docid+'","threply_id":"'+valId+'","threply_stat":"'+nextstat+'","form_id":"form-publish-reply"}';
      var urlFetch = global.config.urlLink+"/threadedit";
      var data = JSON.parse(datatext);
      fetch(urlFetch, {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Authorization': authKey,
          }, body : JSON.stringify(data)
      }).then(res => {
          if(res.status === 200)
              return res.json() 
      }).then( resJson => {
          if(resJson.status === '200') {
              window.location.href=global.config.urlHost+this.state.currPage;
          } else {
              console.log('Something happened wrong');
          }
          
      });
    }
  }
  
  componentDidMount() {
    var content = this.props.value;
    console.log("Block Reply");
    console.log(content);
    var thReplyData = content.data;
    console.log(thReplyData.subcontent.replyMessage)
    this.setState({
      currPage: content.currpage,
      // activePage: thReplyData.activePage,
      threadid: thReplyData.threadId,
      threadtitle: thReplyData.threadTitle,
      id: thReplyData.subdocid,
      // image: (content.libraryPicture !== "" && content.libraryPicture !== undefined)? content.libraryPicture : NAimage,
      // title: ReplaceText(threadData.threadTitle),
      // categoryid: threadData.threadCategoryId, 
      // category: threadData.threadCategoryName,
      description: thReplyData.subcontent.replyMessage !== undefined? ReplaceOutputTextHTML(thReplyData.subcontent.replyMessage) : "",
      status: thReplyData.subcontent.replyStatus,
      createbyid: thReplyData.subcontent.createById,
      createby: thReplyData.subcontent.createByName,
      createon: thReplyData.subcontent.createDate !== undefined? DateTimeFormats(thReplyData.subcontent.createDate._seconds,"datetime-short") : '',
      lastupdate: thReplyData.subcontent.lastUpdate !== undefined? DateTimeFormats(thReplyData.subcontent.lastUpdate._seconds,"datetime-short") : '',
      // link: '/library/' + ReplacePrefixUrl(content.libraryTitle) + '/' + content.id
      // link: '/library/' + ReplaceAllContent(" ", "-", content.libraryTitle).replace(/[^0-9a-zA-Z-]/g, '').substring(0,50) + '/' + content.id
      // link: (this.state.memberStatus === 'Member' ? '/enroll/' : '/library/') + content.id,
      data: thReplyData,
    });
  }
  
  render() {   
    
    return (
      <div className='w-100' key={this.state.id.slice(0,4)}>
        <div className="discussion-block">
          <div className='mb-4'>{parse(this.state.description)} </div>
          <div className="row">
            <div className='col-4'>
              {this.state.createbyid === this.state.memberId && <>
                <FaPen className="style-action-icons" aria-label="edit" onClick={this.handlePopOpen.bind(this,"modal_show_reply","modal_title_reply", GetText() ? "Edit Tanggapan" : "Edit Response", "modal_content_reply", this.state.data)} />  
                <FaTrash className="style-action-icons" aria-label="delete" onClick={this.handlePublish.bind(this, this.state.threadid, this.state.id, global.config.threadStatus[2])} />  
              </>}
            </div>
            <div className='col-8 d-flex justify-content-end text-end'>
                {GetText() ? "ditanggapi oleh" : "respond by"} {this.state.createby} <br/>
                {GetText() ? "pada" : "on"} {this.state.lastupdate}
            </div>
            
          </div>
        </div>
				{/* <Card className="discussion-block">
					<Card.Body onClick={this.handleOpenPage.bind(this,global.config.urlHost+this.state.currPage+"/"+this.state.id)} className='text-link' >
						<Card.Title>{this.state.title}</Card.Title>
						<Card.Text>
							{this.state.excerpt}
						</Card.Text>
					</Card.Body>
          <Card.Footer className="text-muted">
            {this.contentLikeIcons(this.state.likestatus,this.state.like,this.state.dislike,this.state.createbyid,this.state.memberId,this.state.id,this.state.likestatusid,this.state.likestatususer)}
          </Card.Footer>
				</Card> */}

        <Modal animation={false} show={this.state.modal_show_reply} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_reply")}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modal_title_reply}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DiscussionFormReply value={this.state.modal_content_reply} />
          </Modal.Body>
        </Modal>

        {/* <Modal animation={false} show={this.state.modal_show_detail} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_detail")}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <PromptDetail value={{"currpage": this.state.activePage, "data": this.state.data, "type": "block"}} />
          </Modal.Body>
        </Modal> */}
			</div>
      
      
    )
  }
}